import React, { useEffect } from 'react';
import './CustomChannelPreview.scss';
import { Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { SessionManager } from '../../services/SessionManager/SessionManager';
import { GGCustomMessageType } from '../../components/PageComponents/ChatComponents/GGCustomMessageTypes';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { activate, deactivate } from '../../redux/chatLock/chatLockSlice';
import { setCardMap } from '../../redux/actionCard/paymentCard/paymentCardsByChannelSlice';
import { ActionCardAPIHandler } from '../../services/NetworkClient/BackendAPIs/ActionCardAPIHandler';


const CustomChannelPreview = (props: any) => {
  const dispatch = useDispatch()

  const { channel, setActiveChannel, lastMessage, onChannelSelect } = props
  const { data } = channel
  const { ggData } = data
  const isChatLocked = useSelector(
    (state: RootState) => state.chatLock.lockedChannels[channel.id] === true
  );

  const recipientUserData = ggData?.members?.[0]?.id === SessionManager.shared.buyer?.id ? ggData?.members?.[1] : ggData?.members?.[0]

  const handleLastMessageChange = async (ggCustomMessageData: any) => {
    switch (ggCustomMessageData.type) {
      // Setup a chatlock if the last message of the channel is of type - orderSubmittedBySellerCard else remove the lock
      case GGCustomMessageType.orderSubmittedBySellerCard: 
          dispatch(activate(channel.id ?? ""));
          break;

      case GGCustomMessageType.orderProposalActionTakenCard:
          // refresh actionCards here since last msg is an action taken regarding order proposal which may not have refreshed yet.
        const cardsList = await ActionCardAPIHandler.shared.getActionCardsByChannelId(channel.id);
        if (cardsList) {
          dispatch(setCardMap(cardsList));
        }
        break;
      default:
          
    }

    if (ggCustomMessageData.type !== GGCustomMessageType.orderSubmittedBySellerCard && isChatLocked) {
      dispatch(deactivate(channel.id ?? ""))
    }
  }

  useEffect(() => {
    if (lastMessage && lastMessage.ggCustomMessageData) {
      handleLastMessageChange(lastMessage.ggCustomMessageData)
    } else if (isChatLocked) {
      dispatch(deactivate(channel.id ?? ""))
    }
    // eslint-disable-next-line
  }, [lastMessage])

  const handleChannelClick = () => {
    // Only set active channel if onChannelSelect is provided (user explicitly clicked)
    // This prevents auto-selection when navigating back to the list
    if (onChannelSelect) {
      onChannelSelect(channel.id);
      // Only call setActiveChannel if we're explicitly selecting (not just viewing list)
      // The onChannelSelect handler will manage the active state
      setActiveChannel(channel);
    }
  };

  return (
    <div className="custom-channel-preview" style={{ border: `${props.active ? '1.5px solid blue' : props.unread ? '1.5px solid red' : ''}`, backgroundColor: `${props.active ? 'white' : ''}` }} onClick={handleChannelClick}>
      <Avatar alt={recipientUserData?.name} src={`${recipientUserData?.image}`}></Avatar>
      <div className='channel-preview-content'>
        <div className="channel-header">
          <Typography className='user-name' variant='subtitle2'>{recipientUserData?.name}</Typography>
          <Typography className='gig-title' variant='subtitle1'>: {ggData?.gigTitle}</Typography>
        </div>
        <Typography className='message-text' style={{ fontWeight: `${props.unread ? 'bold' : ''}` }}>{lastMessage?.text}</Typography>
        <div className="channel-preview-body">
          {/* TODO: The following is not working as of now. Need to fix */}
          <Typography className='time' variant='caption'>{lastMessage?.createdAt}</Typography>
        </div>
        <div className='unread-badge' hidden={!props.unread}>{props.unread}</div>
      </div>
    </div>
  );
};

export { CustomChannelPreview };
